import React from 'react';

import SignUpInformations from "../components/SignUpInformation/SignUpInformations";

const SignupStep = (props) => (
    <div id="signup">
        <div className="black-layer"/>
        <div className="container">
            <div className="card">
                <SignUpInformations/>
            </div>
        </div>
    </div>
);

export default SignupStep;

